'use strict';

var bind = require('function-bind');
var $apply = require('./functionApply');
var actualApply = require('./actualApply');

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./~/call-bind-apply-helpers/applyBind.js
// module id = 170
// module chunks = 114276838955818